import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest, AddOnWithCells } from '@frontend/api';

export const useCreateAddOn: MutationFunction<
  AddOnWithCells,
  { componentId: number; data: { addOnDefId?: number; name: string } }
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ componentId, data }) =>
      request(`/quotes/components/${componentId}/add_ons`, {
        init: { method: 'POST', body: data },
        query,
      }),
    ...queryOptions,
  });
};
